import React from 'react';
import Icon from '../../../AppIcon';
import Image from '../../../AppImage';

const ActivityFeed = ({ activities }) => {
  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    
    if (days > 0) return `${days}d ago`;
    if (hours > 0) return `${hours}h ago`;
    if (minutes > 0) return `${minutes}m ago`;
    return 'Just now';
  };

  const getActivityIcon = (type) => {
    const iconMap = {
      match: 'Users',
      application: 'FileText',
      referral: 'UserPlus',
      program: 'Briefcase',
      verification: 'Shield',
      message: 'MessageCircle',
      payment: 'DollarSign'
    };
    return iconMap?.[type] || 'Bell';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      match: 'text-success',
      application: 'text-primary',
      referral: 'text-accent',
      program: 'text-warning',
      verification: 'text-trust',
      message: 'text-muted-foreground',
      payment: 'text-success'
    };
    return colorMap?.[type] || 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          View All
        </button>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-colors duration-200">
            <div className={`p-2 rounded-full bg-muted ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={16} />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-1">
                {activity?.avatar && (
                  <Image
                    src={activity?.avatar}
                    alt={activity?.avatarAlt}
                    className="w-6 h-6 rounded-full object-cover"
                  />
                )}
                <p className="text-sm font-medium text-foreground truncate">
                  {activity?.title}
                </p>
              </div>
              
              <p className="text-sm text-muted-foreground mb-2">
                {activity?.description}
              </p>
              
              <div className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground">
                  {getTimeAgo(activity?.timestamp)}
                </span>
                {activity?.status && (
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    activity?.status === 'success' ? 'bg-success/10 text-success' :
                    activity?.status === 'pending'? 'bg-warning/10 text-warning' : 'bg-error/10 text-error'
                  }`}>
                    {activity?.status}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;